module.exports = __webpack_public_path__ + "img/刺五加.38f626e7.jpg";